// Mot de passe temporaire donné par l'admin (sécurité 2026-11-02) : le serveur refuse tout (403
// `password_change_required`) tant qu'un nouveau mot de passe n'a pas été choisi. Même rôle que le
// PasswordChangeGate des apps : fenêtre bloquante, mot de passe temporaire + nouveau mot de passe →
// POST /account/password, puis rechargement avec le jeton neuf.
import React, { useEffect, useState } from 'react';
import apiService from './apiService';

const EVENT = 'mbiyo:password-change-required';

export default function PasswordGate({ children }) {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);
  const userType = localStorage.getItem('driverToken') && !localStorage.getItem('userToken') ? 'driver' : 'user';

  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener(EVENT, show);
    const token = localStorage.getItem('userToken') || localStorage.getItem('driverToken');
    if (token) {
      apiService.get('/account/password-status', { userType, silent401: true })
        .then((r) => { if (r?.must_change_password) setVisible(true); })
        .catch(() => {});
    }
    return () => window.removeEventListener(EVENT, show);
  }, [userType]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!current) return setError('Entrez le mot de passe temporaire reçu.');
    if (next.length < 8) return setError('Le nouveau mot de passe doit contenir au moins 8 caractères.');
    if (next !== confirm) return setError('Les deux mots de passe ne correspondent pas.');
    setSending(true);
    try {
      const r = await apiService.post('/account/password', { currentPassword: current, newPassword: next }, { userType });
      if (r?.success) {
        if (r.token) apiService.setToken(r.token, userType);
        window.location.reload();
        return;
      }
      setError(r?.error || 'Impossible de changer le mot de passe.');
    } catch (err) {
      setError(err?.error || err?.message || 'Impossible de changer le mot de passe.');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {children}
      {visible && (
        <div className="mb-pwd-overlay" role="dialog" aria-modal="true" aria-labelledby="mb-pwd-title">
          <style>{`.mb-pwd-overlay{position:fixed;inset:0;z-index:10001;background:rgba(10,10,10,.72);display:flex;align-items:center;justify-content:center;padding:16px}.mb-pwd-card{background:#fff;color:#1f2328;width:100%;max-width:440px;max-height:calc(100dvh - 32px);overflow:auto;border-radius:20px;padding:26px 22px 20px;box-shadow:0 24px 60px rgba(0,0,0,.35);font-family:inherit}`}</style>
          <div className="mb-pwd-card">
            <h2 id="mb-pwd-title" style={{ marginTop: 0 }}>Nouveau mot de passe requis</h2>
            <p style={{ color: '#5C636E', fontSize: '0.95rem', lineHeight: 1.5 }}>
              Un mot de passe temporaire vous a été remis par l'équipe Mbiyo. Pour continuer, choisissez maintenant
              votre propre mot de passe.
            </p>
            <form onSubmit={submit} style={{ display: 'grid', gap: 10 }}>
              <input type="password" placeholder="Mot de passe temporaire" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" style={{ padding: '12px 14px', borderRadius: 10, border: '1px solid #DCE0E6', fontSize: '1rem' }} />
              <input type="password" placeholder="Nouveau mot de passe (8 caractères minimum)" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" style={{ padding: '12px 14px', borderRadius: 10, border: '1px solid #DCE0E6', fontSize: '1rem' }} />
              <input type="password" placeholder="Confirmer le nouveau mot de passe" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" style={{ padding: '12px 14px', borderRadius: 10, border: '1px solid #DCE0E6', fontSize: '1rem' }} />
              {error && <p style={{ color: '#DC2626', fontSize: '0.9rem', margin: 0 }}>{error}</p>}
              <button type="submit" disabled={sending} style={{ padding: '13px 16px', borderRadius: 12, border: 'none', background: '#F54119', color: '#fff', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}>
                {sending ? 'Enregistrement…' : 'Enregistrer mon mot de passe'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
